import { render, staticRenderFns } from "./dictionaries.vue?vue&type=template&id=44496740&"
import script from "./dictionaries.vue?vue&type=script&lang=js&"
export * from "./dictionaries.vue?vue&type=script&lang=js&"
import style0 from "./dictionaries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports